import AddClass from './AddClass';

export default AddClass;
